var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0599 16.0599C12.7787 16.3408 12.3974 16.4986 11.9999 16.4986C11.6024 16.4986 11.2212 16.3408 10.9399 16.0599L5.2819 10.4039C5.00064 10.1225 4.84268 9.74089 4.84277 9.34304C4.84287 8.94518 5.00101 8.56365 5.2824 8.28239C5.56379 8.00113 5.9454 7.84317 6.34325 7.84326C6.74111 7.84336 7.12264 8.00149 7.4039 8.28289L11.9999 12.8789L16.5959 8.28289C16.8787 8.00952 17.2575 7.85814 17.6508 7.86137C18.0441 7.8646 18.4204 8.02218 18.6986 8.30016C18.9769 8.57815 19.1348 8.95429 19.1384 9.34759C19.142 9.74088 18.991 10.1199 18.7179 10.4029L13.0609 16.0609L13.0599 16.0599Z",
    fill: "#5F5D5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/drop_down.cca01436668c87da8278a5e56f429f15.svg";
export { ForwardRef as ReactComponent };